import { Box, List, ListItemWithIcon, Typography } from "@bca/ui-library";

import { Item } from "../vehicleDetails/vehicle-details.type";

interface AdvisoryItemsProps {
  advisoryItems?: Item[];
}

const AdditionalInfoSection = ({ advisoryItems }: AdvisoryItemsProps) => {
  if (Boolean(advisoryItems) && advisoryItems?.length > 0)
    return (
      <Box marginBottom="44px">
        <Typography variant="h5" css="margin: 0 0 24px 0;">
          Additional Information
        </Typography>
        <Box display="flex" flexWrap="wrap" justifyContent="flex-start">
          <List
            css={`
              margin-top: 0;
              padding-top: 0;
            `}
          >
            {advisoryItems?.map((item) => (
              <ListItemWithIcon
                icon="circle"
                iconColor="grey-blue"
                iconWeight="solid"
                iconWidth={5}
                key={item?.name}
              >
                {item?.name}
              </ListItemWithIcon>
            ))}
          </List>
        </Box>
      </Box>
    );
  return (
    <Box marginBottom="44px" marginTop={{ mobile: 0, tablet: 0, desktop: 0 }}>
      <Typography variant="h5" css="margin: 0 0 24px 0;">
        Additional Information
      </Typography>
      <Typography
        variant="body"
        fontStyle="italic"
        color="grey-blue"
        fontWeight="normal"
      >
        No additional information
      </Typography>
    </Box>
  );
};

export default AdditionalInfoSection;
